
define(['core'], function(core) {
  return {
    isCtrlKeyDown: function(event) {
      if (core.isMac()) {
        return event.metaKey;
      } else {
        return event.ctrlKey;
      }
    },
    isCtrlAndKeyDown: function(event, key) {
      var keyCode;
      keyCode = key.charCodeAt(0);
      return this.isCtrlKeyDown(event) && keyCode === (event.which || event.keyCode);
    }
  };
});
